import React, { useState, useEffect } from 'react';
import SelecionarCategoriaProduto from '../Utils/SelecionarCategoriaProduto';
import SelecionarMarca from '../Utils/SelecionarMarca';
import ImageCropper from '../Utils/ImageCropper';
import { Form, Button, Card, Alert, Row, Col, InputGroup, Table} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PhoneInput from '../Input/PhoneInput'
import { useProvider, Toast, isNative } from '../../context/MenuProvider';


const ConfiguracoesForm = () => {
    const navigate = useNavigate();
    const { 
      setLinks, 
      setBtns,
      crud,
      auth,
      buscarDados,
      salvarDados,
      navigateTo,
      lista,
    } = useProvider();
    const { put, get, loading } = crud || {};
    const [grupos, setGrupos] = useState([]);


    useEffect(()=>{
      const carregarConfiguracoes = async()=>{
        try{
          const url = [
            `/core/usuarios/?filtros=groups`,
            `/core/grupos/?filtros=id,name&ordering=name`,
          ]
          const response = await get(url,'configuracoes');
          //alert(JSON.stringify(response[0].results[0]))
          if(response && response.length){
            const listaSelecionada = response[0].results[0].groups;
            const listaGrupos = response[1].results;
            for (const item of listaGrupos) {
              item.checked = listaSelecionada.some(id => id === item.id);
            }
            setGrupos(listaGrupos);
          }
        }catch(err){

        }
      }
      carregarConfiguracoes();
    }, [])
    

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([{ icon: 'bi-check-lg', onClick: handleSubmit }]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, grupos]); // Removidas dependências desnecessárias
    

    const handleSubmit = async (e) => {
        e?.preventDefault();
        
        const grupo_ids = grupos.filter(x => x.checked).map(x => x.id);

        try {
            const response = await put({
              groups:grupo_ids
            }, `/core/usuarios/grupos/`);
            if (response && response.length) {
              if(isNative) window.dispatchNativeMessage('refresh-token');
              if(!isNative) navigator.serviceWorker.controller.postMessage('refresh-token');
              Toast.fire({
                  icon: "success",
                  title: `Altualizado com sucesso`
              });
              navigateTo(-1);
            }
        } catch (err) {
        }
    };
    
    
    return (
      <>
        <div className="table-responsive">
          <Table className="table table-bordered">
            <thead className="table-dark">
              <tr className="text-center">
                <th scope="col">Funções do Sistema</th>
              </tr>
            </thead>
            <tbody>
              {grupos.map((item, index) => (
                <tr className="text-center">
                  <td scope="col">
                    <Row>
                      <Col>
                        <Form.Group controlId={`group_${index}`}>
                          <Form.Check
                            type="switch"
                            label={item.name}
                            checked={item.checked}
                            onChange={(e) =>
                              setGrupos((prev) =>
                                prev.map((g) =>
                                  g.id === item.id ? { ...g, checked: e.target.checked } : g
                                )
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
    
        <Button
          variant="dark"
          type="submit"
          className="mt-4 w-100"
          disabled={loading}
          onClick={handleSubmit}
        >
          Salvar Configurações
        </Button>
      </>
    );
};


export default ConfiguracoesForm;

